export const REFERRAL_ATTEMPTED_STORAGE_KEY = 'hy_ref_attempted';

export const TERMINAL_ATTRIBUTION_STATUSES = new Set([
  'attributed',
  'already_attributed',
  'self_referral',
  'unknown_code',
  'window_expired',
]);

export function shouldAttemptAttribution({ isSignedIn, storedCode, attempted }) {
  return Boolean(isSignedIn && storedCode && !attempted);
}

/** Pure decision used by the signed-in effect to apply storage side effects. */
export function attributionStorageAction({ status, error = false }) {
  if (error) {
    return { clearStoredCode: false, clearAttempted: true };
  }

  const terminal = TERMINAL_ATTRIBUTION_STATUSES.has(status);
  return {
    clearStoredCode: terminal,
    clearAttempted: !terminal,
  };
}

export function readAttributionAttempted() {
  try {
    return window.localStorage.getItem(REFERRAL_ATTEMPTED_STORAGE_KEY) === '1';
  } catch (error) {
    console.error('Referral attribution attempt state could not be read from localStorage.', error);
    return false;
  }
}

export function markAttributionAttempted() {
  try {
    window.localStorage.setItem(REFERRAL_ATTEMPTED_STORAGE_KEY, '1');
  } catch (error) {
    console.error('Referral attribution attempt state could not be stored in localStorage.', error);
  }
}

export function clearAttributionAttempted() {
  try {
    window.localStorage.removeItem(REFERRAL_ATTEMPTED_STORAGE_KEY);
  } catch (error) {
    console.error('Referral attribution attempt state could not be cleared from localStorage.', error);
  }
}
